module.exports = __webpack_public_path__ + "static/media/carousel-new-4.171cb40b.png";